/**
 * AutoCAD Color Index (ACI) palette — 255 standard colors.
 * Used to convert RGB values to the nearest DXF color index.
 */

interface AciColor {
  index: number;
  r: number;
  g: number;
  b: number;
}

const aciColors: AciColor[] = [
  { index: 1, r: 255, g: 0, b: 0 },
  { index: 2, r: 255, g: 255, b: 0 },
  { index: 3, r: 0, g: 255, b: 0 },
  { index: 4, r: 0, g: 255, b: 255 },
  { index: 5, r: 0, g: 0, b: 255 },
  { index: 6, r: 255, g: 0, b: 255 },
  { index: 8, r: 65, g: 65, b: 65 },
  { index: 9, r: 128, g: 128, b: 128 },
  { index: 10, r: 255, g: 0, b: 0 },
  { index: 11, r: 255, g: 170, b: 170 },
  { index: 12, r: 189, g: 0, b: 0 },
  { index: 13, r: 189, g: 126, b: 126 },
  { index: 14, r: 129, g: 0, b: 0 },
  { index: 15, r: 129, g: 86, b: 86 },
  { index: 16, r: 104, g: 0, b: 0 },
  { index: 17, r: 104, g: 69, b: 69 },
  { index: 18, r: 79, g: 0, b: 0 },
  { index: 19, r: 79, g: 53, b: 53 },
  { index: 20, r: 255, g: 63, b: 0 },
  { index: 21, r: 255, g: 191, b: 170 },
  { index: 22, r: 189, g: 46, b: 0 },
  { index: 23, r: 189, g: 141, b: 126 },
  { index: 24, r: 129, g: 31, b: 0 },
  { index: 25, r: 129, g: 96, b: 86 },
  { index: 26, r: 104, g: 25, b: 0 },
  { index: 27, r: 104, g: 78, b: 69 },
  { index: 28, r: 79, g: 19, b: 0 },
  { index: 29, r: 79, g: 59, b: 53 },
  { index: 30, r: 255, g: 127, b: 0 },
  { index: 31, r: 255, g: 212, b: 170 },
  { index: 32, r: 189, g: 94, b: 0 },
  { index: 33, r: 189, g: 157, b: 126 },
  { index: 34, r: 129, g: 64, b: 0 },
  { index: 35, r: 129, g: 107, b: 86 },
  { index: 36, r: 104, g: 52, b: 0 },
  { index: 37, r: 104, g: 86, b: 69 },
  { index: 38, r: 79, g: 39, b: 0 },
  { index: 39, r: 79, g: 66, b: 53 },
  { index: 40, r: 255, g: 191, b: 0 },
  { index: 41, r: 255, g: 234, b: 170 },
  { index: 42, r: 189, g: 141, b: 0 },
  { index: 43, r: 189, g: 173, b: 126 },
  { index: 44, r: 129, g: 96, b: 0 },
  { index: 45, r: 129, g: 118, b: 86 },
  { index: 46, r: 104, g: 78, b: 0 },
  { index: 47, r: 104, g: 95, b: 69 },
  { index: 48, r: 79, g: 59, b: 0 },
  { index: 49, r: 79, g: 73, b: 53 },
  { index: 50, r: 255, g: 255, b: 0 },
  { index: 51, r: 255, g: 255, b: 170 },
  { index: 52, r: 189, g: 189, b: 0 },
  { index: 53, r: 189, g: 189, b: 126 },
  { index: 54, r: 129, g: 129, b: 0 },
  { index: 55, r: 129, g: 129, b: 86 },
  { index: 56, r: 104, g: 104, b: 0 },
  { index: 57, r: 104, g: 104, b: 69 },
  { index: 58, r: 79, g: 79, b: 0 },
  { index: 59, r: 79, g: 79, b: 53 },
  { index: 60, r: 191, g: 255, b: 0 },
  { index: 61, r: 234, g: 255, b: 170 },
  { index: 62, r: 141, g: 189, b: 0 },
  { index: 63, r: 173, g: 189, b: 126 },
  { index: 64, r: 96, g: 129, b: 0 },
  { index: 65, r: 118, g: 129, b: 86 },
  { index: 66, r: 78, g: 104, b: 0 },
  { index: 67, r: 95, g: 104, b: 69 },
  { index: 68, r: 59, g: 79, b: 0 },
  { index: 69, r: 73, g: 79, b: 53 },
  { index: 70, r: 127, g: 255, b: 0 },
  { index: 71, r: 212, g: 255, b: 170 },
  { index: 72, r: 94, g: 189, b: 0 },
  { index: 73, r: 157, g: 189, b: 126 },
  { index: 74, r: 64, g: 129, b: 0 },
  { index: 75, r: 107, g: 129, b: 86 },
  { index: 76, r: 52, g: 104, b: 0 },
  { index: 77, r: 86, g: 104, b: 69 },
  { index: 78, r: 39, g: 79, b: 0 },
  { index: 79, r: 66, g: 79, b: 53 },
  { index: 80, r: 63, g: 255, b: 0 },
  { index: 81, r: 191, g: 255, b: 170 },
  { index: 82, r: 46, g: 189, b: 0 },
  { index: 83, r: 141, g: 189, b: 126 },
  { index: 84, r: 31, g: 129, b: 0 },
  { index: 85, r: 96, g: 129, b: 86 },
  { index: 86, r: 25, g: 104, b: 0 },
  { index: 87, r: 78, g: 104, b: 69 },
  { index: 88, r: 19, g: 79, b: 0 },
  { index: 89, r: 59, g: 79, b: 53 },
  { index: 90, r: 0, g: 255, b: 0 },
  { index: 91, r: 170, g: 255, b: 170 },
  { index: 92, r: 0, g: 189, b: 0 },
  { index: 93, r: 126, g: 189, b: 126 },
  { index: 94, r: 0, g: 129, b: 0 },
  { index: 95, r: 86, g: 129, b: 86 },
  { index: 96, r: 0, g: 104, b: 0 },
  { index: 97, r: 69, g: 104, b: 69 },
  { index: 98, r: 0, g: 79, b: 0 },
  { index: 99, r: 53, g: 79, b: 53 },
  { index: 100, r: 0, g: 255, b: 63 },
  { index: 101, r: 170, g: 255, b: 191 },
  { index: 102, r: 0, g: 189, b: 46 },
  { index: 103, r: 126, g: 189, b: 141 },
  { index: 104, r: 0, g: 129, b: 31 },
  { index: 105, r: 86, g: 129, b: 96 },
  { index: 106, r: 0, g: 104, b: 25 },
  { index: 107, r: 69, g: 104, b: 78 },
  { index: 108, r: 0, g: 79, b: 19 },
  { index: 109, r: 53, g: 79, b: 59 },
  { index: 110, r: 0, g: 255, b: 127 },
  { index: 111, r: 170, g: 255, b: 212 },
  { index: 112, r: 0, g: 189, b: 94 },
  { index: 113, r: 126, g: 189, b: 157 },
  { index: 114, r: 0, g: 129, b: 64 },
  { index: 115, r: 86, g: 129, b: 107 },
  { index: 116, r: 0, g: 104, b: 52 },
  { index: 117, r: 69, g: 104, b: 86 },
  { index: 118, r: 0, g: 79, b: 39 },
  { index: 119, r: 53, g: 79, b: 66 },
  { index: 120, r: 0, g: 255, b: 191 },
  { index: 121, r: 170, g: 255, b: 234 },
  { index: 122, r: 0, g: 189, b: 141 },
  { index: 123, r: 126, g: 189, b: 173 },
  { index: 124, r: 0, g: 129, b: 96 },
  { index: 125, r: 86, g: 129, b: 118 },
  { index: 126, r: 0, g: 104, b: 78 },
  { index: 127, r: 69, g: 104, b: 95 },
  { index: 128, r: 0, g: 79, b: 59 },
  { index: 129, r: 53, g: 79, b: 73 },
  { index: 130, r: 0, g: 255, b: 255 },
  { index: 131, r: 170, g: 255, b: 255 },
  { index: 132, r: 0, g: 189, b: 189 },
  { index: 133, r: 126, g: 189, b: 189 },
  { index: 134, r: 0, g: 129, b: 129 },
  { index: 135, r: 86, g: 129, b: 129 },
  { index: 136, r: 0, g: 104, b: 104 },
  { index: 137, r: 69, g: 104, b: 104 },
  { index: 138, r: 0, g: 79, b: 79 },
  { index: 139, r: 53, g: 79, b: 79 },
  { index: 140, r: 0, g: 191, b: 255 },
  { index: 141, r: 170, g: 234, b: 255 },
  { index: 142, r: 0, g: 141, b: 189 },
  { index: 143, r: 126, g: 173, b: 189 },
  { index: 144, r: 0, g: 96, b: 129 },
  { index: 145, r: 86, g: 118, b: 129 },
  { index: 146, r: 0, g: 78, b: 104 },
  { index: 147, r: 69, g: 95, b: 104 },
  { index: 148, r: 0, g: 59, b: 79 },
  { index: 149, r: 53, g: 73, b: 79 },
  { index: 150, r: 0, g: 127, b: 255 },
  { index: 151, r: 170, g: 212, b: 255 },
  { index: 152, r: 0, g: 94, b: 189 },
  { index: 153, r: 126, g: 157, b: 189 },
  { index: 154, r: 0, g: 64, b: 129 },
  { index: 155, r: 86, g: 107, b: 129 },
  { index: 156, r: 0, g: 52, b: 104 },
  { index: 157, r: 69, g: 86, b: 104 },
  { index: 158, r: 0, g: 39, b: 79 },
  { index: 159, r: 53, g: 66, b: 79 },
  { index: 160, r: 0, g: 63, b: 255 },
  { index: 161, r: 170, g: 191, b: 255 },
  { index: 162, r: 0, g: 46, b: 189 },
  { index: 163, r: 126, g: 141, b: 189 },
  { index: 164, r: 0, g: 31, b: 129 },
  { index: 165, r: 86, g: 96, b: 129 },
  { index: 166, r: 0, g: 25, b: 104 },
  { index: 167, r: 69, g: 78, b: 104 },
  { index: 168, r: 0, g: 19, b: 79 },
  { index: 169, r: 53, g: 59, b: 79 },
  { index: 170, r: 0, g: 0, b: 255 },
  { index: 171, r: 170, g: 170, b: 255 },
  { index: 172, r: 0, g: 0, b: 189 },
  { index: 173, r: 126, g: 126, b: 189 },
  { index: 174, r: 0, g: 0, b: 129 },
  { index: 175, r: 86, g: 86, b: 129 },
  { index: 176, r: 0, g: 0, b: 104 },
  { index: 177, r: 69, g: 69, b: 104 },
  { index: 178, r: 0, g: 0, b: 79 },
  { index: 179, r: 53, g: 53, b: 79 },
  { index: 180, r: 63, g: 0, b: 255 },
  { index: 181, r: 191, g: 170, b: 255 },
  { index: 182, r: 46, g: 0, b: 189 },
  { index: 183, r: 141, g: 126, b: 189 },
  { index: 184, r: 31, g: 0, b: 129 },
  { index: 185, r: 96, g: 86, b: 129 },
  { index: 186, r: 25, g: 0, b: 104 },
  { index: 187, r: 78, g: 69, b: 104 },
  { index: 188, r: 19, g: 0, b: 79 },
  { index: 189, r: 59, g: 53, b: 79 },
  { index: 190, r: 127, g: 0, b: 255 },
  { index: 191, r: 212, g: 170, b: 255 },
  { index: 192, r: 94, g: 0, b: 189 },
  { index: 193, r: 157, g: 126, b: 189 },
  { index: 194, r: 64, g: 0, b: 129 },
  { index: 195, r: 107, g: 86, b: 129 },
  { index: 196, r: 52, g: 0, b: 104 },
  { index: 197, r: 86, g: 69, b: 104 },
  { index: 198, r: 39, g: 0, b: 79 },
  { index: 199, r: 66, g: 53, b: 79 },
  { index: 200, r: 191, g: 0, b: 255 },
  { index: 201, r: 234, g: 170, b: 255 },
  { index: 202, r: 141, g: 0, b: 189 },
  { index: 203, r: 173, g: 126, b: 189 },
  { index: 204, r: 96, g: 0, b: 129 },
  { index: 205, r: 118, g: 86, b: 129 },
  { index: 206, r: 78, g: 0, b: 104 },
  { index: 207, r: 95, g: 69, b: 104 },
  { index: 208, r: 59, g: 0, b: 79 },
  { index: 209, r: 73, g: 53, b: 79 },
  { index: 210, r: 255, g: 0, b: 255 },
  { index: 211, r: 255, g: 170, b: 255 },
  { index: 212, r: 189, g: 0, b: 189 },
  { index: 213, r: 189, g: 126, b: 189 },
  { index: 214, r: 129, g: 0, b: 129 },
  { index: 215, r: 129, g: 86, b: 129 },
  { index: 216, r: 104, g: 0, b: 104 },
  { index: 217, r: 104, g: 69, b: 104 },
  { index: 218, r: 79, g: 0, b: 79 },
  { index: 219, r: 79, g: 53, b: 79 },
  { index: 220, r: 255, g: 0, b: 191 },
  { index: 221, r: 255, g: 170, b: 234 },
  { index: 222, r: 189, g: 0, b: 141 },
  { index: 223, r: 189, g: 126, b: 173 },
  { index: 224, r: 129, g: 0, b: 96 },
  { index: 225, r: 129, g: 86, b: 118 },
  { index: 226, r: 104, g: 0, b: 78 },
  { index: 227, r: 104, g: 69, b: 95 },
  { index: 228, r: 79, g: 0, b: 59 },
  { index: 229, r: 79, g: 53, b: 73 },
  { index: 230, r: 255, g: 0, b: 127 },
  { index: 231, r: 255, g: 170, b: 212 },
  { index: 232, r: 189, g: 0, b: 94 },
  { index: 233, r: 189, g: 126, b: 157 },
  { index: 234, r: 129, g: 0, b: 64 },
  { index: 235, r: 129, g: 86, b: 107 },
  { index: 236, r: 104, g: 0, b: 52 },
  { index: 237, r: 104, g: 69, b: 86 },
  { index: 238, r: 79, g: 0, b: 39 },
  { index: 239, r: 79, g: 53, b: 66 },
  { index: 240, r: 255, g: 0, b: 63 },
  { index: 241, r: 255, g: 170, b: 191 },
  { index: 242, r: 189, g: 0, b: 46 },
  { index: 243, r: 189, g: 126, b: 141 },
  { index: 244, r: 129, g: 0, b: 31 },
  { index: 245, r: 129, g: 86, b: 96 },
  { index: 246, r: 104, g: 0, b: 25 },
  { index: 247, r: 104, g: 69, b: 78 },
  { index: 248, r: 79, g: 0, b: 19 },
  { index: 249, r: 79, g: 53, b: 59 },
  { index: 250, r: 51, g: 51, b: 51 },
  { index: 251, r: 91, g: 91, b: 91 },
  { index: 252, r: 132, g: 132, b: 132 },
  { index: 253, r: 173, g: 173, b: 173 },
  { index: 254, r: 214, g: 214, b: 214 },
  { index: 255, r: 255, g: 255, b: 255 },
];

const NEAR_BLACK_WHITE_THRESHOLD = 7;
const DEFAULT_COLOR_INDEX = 7; // white/black fallback

/**
 * Convert an RGB color (0-255 per channel) to the nearest ACI color index.
 * Near-black and near-white colors map to index 7.
 */
export function rgbToAciColor(r: number, g: number, b: number): number {
  r = Math.round(r);
  g = Math.round(g);
  b = Math.round(b);

  const sum = r + g + b;
  if (sum < NEAR_BLACK_WHITE_THRESHOLD || sum > 765 - NEAR_BLACK_WHITE_THRESHOLD) {
    return DEFAULT_COLOR_INDEX;
  }

  let closestIndex = DEFAULT_COLOR_INDEX;
  let smallestDistance = Infinity;

  for (const color of aciColors) {
    const dr = color.r - r;
    const dg = color.g - g;
    const db = color.b - b;
    const distance = dr * dr + dg * dg + db * db;

    if (distance < smallestDistance) {
      smallestDistance = distance;
      closestIndex = color.index;
    }
  }

  return closestIndex;
}
